// extracted by mini-css-extract-plugin
module.exports = {"text-area":"BlogDetails_text-area__rrcRO"};